import { Colors, Styles } from "../preset.constants";

export const chipPreset = {
    root: {
        background: Colors.DisabledBackground,
        borderRadius: Styles.BorderRadiusSM,
        color: Colors.Primary
    },
    removeIcon: {
        color: Colors.Primary
    }
}